import PaymentGatewayCommon from '@/app-core/mixins/payment/paymentGatewayCommon'
import API from '@/app-core/api/Api'
import OtpDialog from '@/app-theme/components/common/OtpDialog.vue'

export default {
  name      : 'GenericPaymentGateway',
  components: {OtpDialog},
  directives: {},
  mixins    : [PaymentGatewayCommon],
  props     : {
    model: {
      type   : Object,
      default: undefined
    }
  },
  enums    : {},
  dataStore: {
    AppCart: 'App.Cart'
  },
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onRequestSuccess(response) {
      const data = API.responseData(response)
      if (!data?.OrderId) {
        this.loading = false
        return
      }

      this.requestUpdateCart(response)
      this.requestSuccessNotify(response)
      this.parseRequestMessages(response)

      this.$router.replace({
        name  : 'CheckoutSuccess',
        params: {orderId: data.OrderId}
      })
    }
  }
}
